<template>
  <v-container>
    <v-row align="center">
      <v-col cols="8">
        <v-data-table
          disable-pagination
          hide-default-footer
          :items="values"
          :headers="headers"
        >
          <template v-slot:top>
            <v-toolbar dense color="primary" dark>
              <v-row justify="center">
                <v-col cols="2" align="center">
                  <v-btn small light @click="addValue">
                    <v-icon color="success">mdi-plus</v-icon>
                  </v-btn>
                </v-col>

                <v-col cols="2" align="center">
                  <v-btn small light @click="clickSend">
                    <v-icon color="indigo">mdi-send</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-toolbar>
          </template>

          <template v-slot:[`item.field`]="{ item }">
            <v-text-field label="Campo" v-model="item.field" />
          </template>

          <template v-slot:[`item.value`]="{ item }">
            <v-text-field label="Valore" v-model="item.value" />
          </template>

          <template v-slot:[`item.delete`]="{ item }">
            <v-btn small light @click="removeValue(item)">
              <v-icon color="error">mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>

      <!-- Dialog del componente dinamico -->
      <v-dialog v-model="window_frame_visible">
        <WindowFrame
          override="http://localhost:8081"
          @loaded="handleLoaded"
          ref="module"
        />
        <!--<WindowFrame component="micro" @loaded="handleLoaded" ref="module" />-->
      </v-dialog>
    </v-row>
  </v-container>
</template>
<script>
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";
export default {
  name: "MicroTestView",
  components: {
    WindowFrame,
  },
  data() {
    return {
      // Variabili d'appoggio
      modulo_sel: "",

      // Modal
      window_frame_visible: false,

      // Array
      headers: [
        { text: "Campo", value: "field" },
        { text: "Valore", value: "value" },
        { text: "Elimina", value: "delete" },
      ],
      values: new Array(),
    };
  },
  methods: {
    addValue() {
      this.values.push({
        field: null,
        value: null,
      });
    },
    configuraArticolo() {
      console.log("Entrato articolo.");
    },
    configuraMacchina() {
      console.log("Entrata macchina.");
    },
    handleLoaded() {
      this.sendValues();
      switch (this.modulo_sel) {
        case 1:
          this.configuraArticolo();
          break;
        case 2:
          this.configuraMacchina();
          break;
      }
    },
    removeValue(item) {
      const index = this.values.indexOf(item);
      if (index >= 0) {
        this.values.splice(index, 1);
      }
    },
    sendValues(){
      const data = new Object();
      this.values.forEach((value) => {
        data[value.field] = value.value;
      });
      this.$refs.module.postEvent("test_event", data);
    },
    clickSend() {
      /* Se esiste già un modulo a cui spedire le informazioni,
       * le spedisco; altrimenti la spedizione di informazioni
       * viene eseguita in handleLoaded. */
      if(this.$refs.module){
        this.sendValues();
      }

      this.window_frame_visible = true;
    },
  },
};
</script>
<style scoped>
</style>